import React, { useContext, useEffect, useState } from "react";
import { Link, NavLink } from "react-router-dom";
import FormContext from "../../context/FormContext";
import "./navbar.css";

function Navbar() {
  const [currentwidthofdevice, setCurrentwidthofdevice] = useState("0");
  const context = useContext(FormContext);
  const { sidebarToggle, setSidebarToggle } = context;

  const checkwidth = () => {
    setCurrentwidthofdevice(window.innerWidth);
    if (window.innerWidth > 786) {
      setSidebarToggle(true);
    }
  };

  useEffect(() => {
    checkwidth(); // eslint-disable-next-line
  }, []); // eslint-disable-next-line

  return (
    <React.Fragment>
      <div>
        <nav
          className="navbar navbar-expand-lg navbar-light"
          style={{
            backgroundColor: "#25596c",
            boxShadow: "rgb(98 98 98) 0px 15px 10px -15px",
          }}
        >
          {currentwidthofdevice < 786 ? (
            <div className="ms-3">
              <NavLink
                className="text-light"
                onClick={() => setSidebarToggle(!sidebarToggle)}
              >
                <i className="fa-solid fa-bars"></i>
              </NavLink>
            </div>
          ) : null}
          <div className="ms-auto me-3 p-2">
            <Link
              className="mx-2 text-light"
              style={{ textDecoration: "none" }}
              to="/Reports"
            >
              Reports
            </Link>
            <Link
              className="mx-2 text-light"
              style={{ textDecoration: "none" }}
              to="/Formlist"
            >
              Forms List
            </Link>
            <Link
              className="mx-2 text-light"
              style={{ textDecoration: "none" }}
              to="/Home"
            >
              Home
            </Link>
            <Link
              className="mx-2  text-light"
              style={{ textDecoration: "none" }}
              onClick={() => {
                localStorage.clear();
                window.location.reload();
              }}
            >
              Logout
            </Link>
          </div>
        </nav>
      </div>
    </React.Fragment>
  );
}

export default Navbar;
